import { SET_ALERTS, SET_ALERTS_LOADING } from '../saga/alerts/action';

const initialState = {
  data: null,
  isLoading: false
};

export const alertsSelector = state => state.alerts;

export default function alerts(state = initialState, action = {}) {
  switch (action.type) {
    case SET_ALERTS:
      return {
        ...state,
        data: action.payload
      };
    case SET_ALERTS_LOADING:
      return {
        ...state,
        isLoading: action.payload
      };
    default:
      return state;
  }
}
